import { useSealedState } from "reakit-utils/useSealedState";
import { useSelectListState } from "./SelectListState";
import { useSelectPopoverState } from "./SelectPopoverState";
export function useSelectState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sealed = useSealedState(initialState);
  var select = useSelectListState(sealed);
  return useSelectPopoverState(select, sealed);
}
//# sourceMappingURL=SelectState.js.map